import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const SuperAdminGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!auth.isAuthenticated()) {
        router.navigate(['/signin']);
        return false;
    }

    if (!auth.isSuperAdmin()) {
        router.navigate(['/']);
        return false;
    }

    return true;
};
